// TODO: This is only hardcoded for development
export enum Tenant {
  Master = 'master',
  DefaultTenant = 'default_tenant',
  OtherTenant = 'other_tenant',
  CaritasTenant = 'caritas',
  FamilyMember = 'family_member',
}
